// src/redux/slices/generalChatSingleton.js
// A global singleton that owns the shared BondChat socket for the general lounge.

const g = typeof window !== "undefined" ? window : {};

if (!g.__GENERAL_CHAT_SINGLETON__) {
  g.__GENERAL_CHAT_SINGLETON__ = {
    socket: null,
    isInitialized: false,
    listenersAttached: false,
    recentlyProcessed: new Set(),
    processing: new Set(),
  };
}

export const bondChatSingleton = g.__GENERAL_CHAT_SINGLETON__;

export const getBondChatSocket = () => bondChatSingleton.socket;

export const setBondChatSocket = (socket) => {
  bondChatSingleton.socket = socket;
};

export default bondChatSingleton;
